import { gql } from "@apollo/client";

export const GET_VISITOR_BY_USER_ID = gql`
  query GetVisitorByUserId($userId: String!) {
    getVisitorByUserId(userId: $userId) {
      id
      sessionId
      name
      email
      phone
      company
      country
      city
      browser
      device
      isOnline
      firstSeen
      lastSeen
    }
  }
`;

export const UPDATE_VISITOR_INFO = gql`
  mutation UpdateVisitorInfo(
    $sessionId: String!
    $name: String
    $email: String
    $phone: String
    $company: String
    $chatSessionId: ID
  ) {
    updateVisitorInfo(
      sessionId: $sessionId
      name: $name
      email: $email
      phone: $phone
      company: $company
      chatSessionId: $chatSessionId
    ) {
      id
      sessionId
      name
      email
      phone
      company
      chatSessionId
    }
  }
`;
